import { render } from "./AdministratorOnePostContent.vue?vue&type=template&id=11feb6cd&scoped=true"
import script from "./AdministratorOnePostContent.vue?vue&type=script&lang=js"
export * from "./AdministratorOnePostContent.vue?vue&type=script&lang=js"

import "./AdministratorOnePostContent.vue?vue&type=style&index=0&id=11feb6cd&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11feb6cd"]])

export default __exports__